import { queryOptions } from "@tanstack/react-query";
import { getCategoryPlaceData } from "./getCategoryPlaceData";

export const getCategoryPlaceDataOptions = ({ gpid, culture }: { gpid: string; culture: string }) =>
    queryOptions({
        queryKey: ["categoryPlaceData", { gpid, culture }],
        queryFn: () => getCategoryPlaceData({ gpid, culture }),
    });
